module.exports = __webpack_public_path__ + "assets/img/IMG008.feb68209.png";